import { useMemo, createContext, ReactNode } from "react";
import { MetricsIntervalContextProvider } from "./MetricsIntervalContextProvider";
import { MetricDataInterval } from "@tether-web-portal/types/metricsTypes";
import { Property } from "@tether-web-portal/types/Property";

export interface PropertyScopeValue {
  propertyId: string | null;
}

export const PropertyScopeContext = createContext<PropertyScopeValue | null>(null);

export const PropertyProvider = ({
  propertyId,
  defaultInterval,
  children,
}: {
  propertyId: string;
  defaultInterval?: MetricDataInterval;
  children: ReactNode;
}) => {
  const value = useMemo(() => ({ propertyId }), [propertyId]);
  return (
    <PropertyScopeContext.Provider value={value}>
      <MetricsIntervalContextProvider defaultInterval={defaultInterval}>
        {children}
      </MetricsIntervalContextProvider>
    </PropertyScopeContext.Provider>
  );
};
